import { AnchorHTMLAttributes } from "react";

import { useRouter } from "next/navigation";

import { NextLink } from "./styles";

interface ILink extends AnchorHTMLAttributes<HTMLElement> {
  href?: string;
  children: React.ReactNode;
}

const Link = ({ children, href, ...rest }: ILink) => {
  const router = useRouter();

  function handleNavigate() {
    if (href) router.push(href);
  }

  return (
    <NextLink {...rest} onClick={() => handleNavigate()}>
      {children}
    </NextLink>
  );
};

export default Link;
